import { styled } from "@linaria/react"


import { type DropZoneModel } from "@/components/DropZone/DropZoneModel.ts"
import { Horizontal } from "@/components/Flex.ts"
import { AttachRegular, Icon16 } from "@/icons/Icons.ts"

import type { ReactNode } from "react"


export const DropZone = (props: {
  model: DropZoneModel
  placeholder?: ReactNode
}) => {
  return (
    <Container ref={props.model.refCallback}>
      <DropZoneDefaultContent multiple={props.model.multiple} placeholder={props.placeholder} />
    </Container>
  )
}

const DropZoneDefaultContent = (props: {
  multiple: boolean
  placeholder?: ReactNode
}) => {
  return (
    <Horizontal gap="4px" alignItems="center">
      <AttachRegular className={Icon16} />

      <span>
        {props.placeholder || `Click to browse or drag ${props.multiple ? "files" : "a file"} here`}
      </span>
    </Horizontal>
  )
}

const Container = styled.div`
  padding: 8px;

  color: var(--secondary-text-color);
  border: 1px dashed var(--secondary-text-color);
  border-radius: var(--border-radius-4);

  transition: border-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    color: var(--text-color);
    border-color: var(--text-color);
  }
`